"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgStatsStruct = void 0;
const superstruct_1 = require("superstruct");
exports.OrgStatsStruct = (0, superstruct_1.type)({
    totalBulkgateCount: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 0),
    totalSMSCount: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 0),
    totalWhatsappCount: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 0), // number of Whatsapp notifications sent
});
exports.OrgStatsStruct.type = 'OrgStats';
//# sourceMappingURL=orgStats.js.map